document.querySelector('a[href="#zohoForm"].smooth_scroll') && document.querySelector('a[href="#zohoForm"].smooth_scroll').addEventListener("click", doScrolling.bind(null, "#zohoForm", 1e3)), window.addEventListener("load", function() {
    var i = document.getElementById("price__match_myModal"),
        j = document.getElementById("request_callback_myModal"),
        c = document.getElementById("price__match_myBtn"),
        d = document.getElementById("request__callback"),
        e = document.getElementsByClassName("price__match_close")[0],
        f = document.getElementsByClassName("request_callback_close")[0];
    if (c && (c.onclick = function() {
            i.style.display = "block"
        }), d && (d.onclick = function() {
            j.style.display = "block"
        }), e && (e.onclick = function() {
            i.style.display = "none"
        }), f && (f.onclick = function() {
            j.style.display = "none"
        }), window.onclick = function(a) {
            a.target == i && (i.style.display = "none"), a.target == j && (j.style.display = "none")
        }, window.location.href.indexOf("/products/") > -1) {
        var h = document.querySelectorAll(".custom__tab .tablinks");
        h.forEach(function(b, a) {
            h[a].addEventListener("click", function() {
                ! function(d, e) {
                    var a, c, b;
                    for (a = 0, c = document.getElementsByClassName("custom__tabcontent"); a < c.length; a++) c[a].style.display = "none";
                    for (a = 0, b = document.getElementsByClassName("tablinks"); a < b.length; a++) b[a].className = b[a].className.replace(" active", "");
                    document.getElementById(e).style.display = "block", d.classList.add("active")
                }(b, h[a].dataset.tablink)
            })
        }), document.getElementById("default__tab").click()
    }
})

setShippingDetail();


var allNewPincode = [];
        var all_data = [];

        $.getJSON("https://laravel.restaurantequipment.com.au/api/nz-auto", function(data) {
            allNewPincode = data.data;
            all_data = data.all_data;

            var validZip = $('#shipping-estimator-zip').val();

            $.each(all_data,function(k,v){
                if(v.name.indexOf(validZip) != -1){
                    $('#shipping_time').text(v.delivery_time);
                    $('#check_shipping').html(v.name+"<br>");
                }
            })

            $( "#shipping-estimator-zip_popup" ).autocomplete({
                 select: function(event, ui) {
                    console.log(ui, event, 'this');

                    $('#wrong_zip').text('');
                    var valid_zip_main = ui.item.value;
                    var valid_zip_array = valid_zip_main.split(',');
                    var valid_zip = valid_zip_array[valid_zip_array.length - 1].trim();

                    console.log(valid_zip, valid_zip_array, allPincode, "valid_zip valid_zip");

                    if (valid_zip != "" && valid_zip != null) {
                        var province_popup = valid_zip_array[1];

                        if (province_popup != '' && province_popup != null && valid_zip != "" && valid_zip != null) {
                            $('#shipping-estimator-province').val(province_popup.trim());
                            $('#shipping-estimator-zip').val(valid_zip);
                            $('#shipping-estimator-city').val(valid_zip_array[0]);
                            $('#shipping-estimator').find('.form__submit').trigger('click');
                            check_zip = valid_zip_main;
                            $('#estimate_shipping_popup').addClass('estimate_shipping_popup_loader');
                            $('.icon--shipping-loader').show();
                            estimate_shipping(valid_zip_main)
                        } else {
                            $('#wrong_zip').text('Enter valid zipcode');
                        }

                    } else {
                        $('#wrong_zip').text('Enter valid zipcode');
                    }


                },
                maxResults: 10,
                source: allNewPincode,
                appendTo: '.kg-location-row'
            });
        })

        var allPincode = [];
        
        $.getJSON("https://cdn.shopify.com/s/files/1/0622/4353/7125/files/newzealand_postcodes.json?v=1648404627", function(data) {
            allPincode = data;
        })



// var allPincode = [];
// $(function() {
//     $("#shipping-estimator-zip_popup").autocomplete({
//         source: function(request, response) {
//             $.ajax({
//                 url: "https://restaurantequipment.com.au/apps/store/get-pincode-list-page",
//                 dataType: "json",
//                 data: {
//                     term: request.term
//                 },
//                 success: function(data) {
//                     if (data.pincodes.length == 0) {
//                         var result = [{
//                             label: 'No results found',
//                             value: response.term
//                         }];
//                         response(result);
//                     } else {
//                         response(data.pincodes);
//                     }
//                     allPincode = data.pincode_list;
//                 }
//             });
//         },
//         select: function(event, ui) {
//             console.log(ui, event, 'this');

//              $('#wrong_zip').text('');
//             var valid_zip_main = ui.item.value;
//             var valid_zip_array = valid_zip_main.split(',');
//             var valid_zip = valid_zip_array[valid_zip_array.length - 1].trim();

//             console.log(valid_zip, valid_zip_array, allPincode, "valid_zip valid_zip");

//             if (valid_zip != "" && valid_zip != null) {
//                 var province_popup = valid_zip_array[1];

//                 if (province_popup != '' && province_popup != null && valid_zip != "" && valid_zip != null) {
//                     console.log(province_popup, valid_zip)
//                     $('#shipping-estimator-province').val(province_popup.trim());
//                     $('#shipping-estimator-zip').val(valid_zip);
//                     $('#shipping-estimator-city').val(valid_zip_array[0]);
//                     $('#shipping-estimator').find('.form__submit').trigger('click');
//                     check_zip = valid_zip_main;
//                     $('#estimate_shipping_popup').addClass('estimate_shipping_popup_loader');
//                     $('.icon--shipping-loader').show();
//                     estimate_shipping(valid_zip_main)
//                 } else {
//                     $('#wrong_zip').text('Enter valid zipcode');
//                 }

//             } else {
//                 $('#wrong_zip').text('Enter valid zipcode');
//             }


//         },
//         dataType: 'json',
//         autoFocus: true,
//         appendTo: '.kg-location-row'
//     });
// });


function setShippingDetail() {
    var checkForZip = localStorage.getItem('zip');
    var country = localStorage.getItem('country');
    var province = localStorage.getItem('province');
    var city = localStorage.getItem('city');
    console.log("checkForZip", checkForZip, country, province, city);

    if (checkForZip != "" && checkForZip != null && checkForZip != undefined) {
        var zip = checkForZip;

        $('#shipping-estimator-city').val(city);
        $('#shipping-estimator-province').val(province);
        $('#shipping-estimator-zip').val(zip);
        $('#shipping-estimator').find('.form__submit').trigger('click');

        estimate_shipping(city + ', ' + province + ', ' + zip);
    } else {
        var zip = 1010;
        var city = 'Auckland Central';
        var province = 'Auckland';

        console.log('else called');
        $('#shipping-estimator-zip').val(zip);
        $('#shipping-estimator-city').val(city);
        $('#shipping-estimator-province').val(province);
        $('#shipping-estimator').find('.form__submit').trigger('click');

        estimate_shipping(city + ', ' + province + ', ' + zip);
    }
}
setTimeout(function() {
    getProductInventory();
    getProductForPage();
}, 500);

function getProductInventory() {
    var payload = {};

    payload.zipcode = $('#shipping-estimator-zip').val();
    $('#shipping-estimator-zip_popup').val(payload.zipcode);
    payload.country = 'NZ';
    payload.province = $('#shipping-estimator-province').val();
    payload.product_id = product_id
    payload.variant_id = variant_id
    payload.quantity = $('.quantity-selector__value').val();
    payload.grams = grams
    payload.sku = sku

    $.ajax({
        url: "https://laravel.restaurantequipment.com.au/api/get-shipping-location-nz",
        type: "POST",
        dataType: "json",
        contentType: "application/json;",
        data: JSON.stringify(payload),
        success: function(data) {
            if (data.success == true) {
                var kgStockSatus = $(data.view).find('.kg-stock-status').first().text().trim();
                if (!isNaN(kgStockSatus) && kgStockSatus !== '') {
                    $('#kg-inventory-high-count').show();
                } else {
                     $('#kg-inventory-high-text').show();
                }

                $('.custom_shipping').html(data.view);
            }
        },
        error: function(err) {
            // check the err for error details
        }
    });
}
const carousel = document.getElementById('carousel');
  const itemWidth = 320; // card width + gap

  function slideLeft() {
    carousel.scrollBy({ left: -itemWidth, behavior: 'smooth' });
  }

  function slideRight() {
    carousel.scrollBy({ left: itemWidth, behavior: 'smooth' });
  }
function getProductForPage(){
    $.ajax({
        url: "https://dashboard.restaurantequipment.com.au/api/product-page",
        type: "POST",
        dataType: "json",
        contentType: "application/json;",
        data: JSON.stringify({sku:sku}),
        success: function(data) {
            if(data.more_products.length > 0){
                $('body').find('#more_products').show();
                setProductTo(data.more_products,'#more_products .carousel-container');

                $('body').find('#same_products').show();
                setProductTo(data.same_products,'#same_products .carousel-container-same-products');
            }
        },
        error: function(err) {
            // check the err for error details
        }
    });
}

function setProductTo(productsToSet,whereToSet){
    $.each(productsToSet,function(key,product){
            console.log(product.vendor_name,'product.vendor_nameproduct.vendor_nameproduct.vendor_nameproduct.vendor_name')
        if(product.vendor_name == 'Restaurant Equipment Online NZ'){
           var vendor_image = product.vendor_image; 
        }else{
            var vendor_image = "https://cdn.shopify.com/s/files/1/0622/4353/7125/files/restaurant-equipment-online-nz.png?v=1771221502"; 
        }
        var productHTML = `<div class="product-card">
            <div class="product-card-content">
                <a href="${product.product_url}" class="kg-product-item-image-wrapper product-item__image-wrapper--with-secondary">
                    <div class="kg-img-wrapper">
                        <figure>
                            <img class="kg-product-item-primary-image" src="${product.main_image}" alt="${product.product_title}">
                            ${product.second_image ? `<img class="kg-product-item-secondary-image product-item__secondary-image image--fade-in" src="${product.second_image}" alt="${product.product_title}" title="${product.sku}">` : `<img class="kg-product-item-secondary-image product-item__secondary-image image--fade-in" src="${product.main_image}" alt="${product.product_title}">`}
                            <noscript>
                                <img src="${product.main_image}" alt="">
                            </noscript>
                        </figure>
                    </div>
                </a>
                <div class="kg-product-item-info">
                    <div class="product-item-info-inner">
                        <a class="kg-product-item-vendor kg-link" href="${product.vendor_url}">
                        <img src="https://${vendor_image}" alt="${product.vendor_name}">
                        </a>
                        <a href="${product.product_url}" class="kg-product-item-title kg-link">
                        ${product.product_title}
                        </a>
                        <p class="kg-product-item-dimension">${product.product_dimensions}</p>
                        <div class="kg-product-reviews"></div>
                        <div class="kg-excluding-price kg-product-item-price-list" style="display:none">
                            <span class="kg-price kg-price--highlight">
                            <span class="visually-hidden">Sale price</span>$${product.price_wo_gst}</span>
                            <span class="kg-price kg-price--compare">
                            ${product.compare_at_price_wo_gst ? `<span class="visually-hidden">Regular price</span>$${product.compare_at_price_wo_gst}` : ''}
                        </div>
                        <div class="kg-including-price kg-product-item-price-list">
                            <span class="kg-price kg-price--highlight">
                            <span class="visually-hidden">Sale price</span>$${product.price}</span>
                            <span class="kg-price kg-price--compare">
                            ${product.compare_at_price ? `<span class="visually-hidden">Regular price</span>$${product.compare_at_price}` : ''}
                        </div>
                        <span class="kg-product-item-inventory" style="color: ${product.stock <= 0 ? 'red' : (product.stock < 3 ? 'red' : 'inherit')}">
                            ${product.stock > 1 ? `In stock` :
                                product.stock <= 0 ? 'Sold out' :
                                product.stock < 3 ? `In stock` : ''}
                        </span>
                    </div>
                    <form method="post" action="/cart/add" id="${product.form_id}" accept-charset="UTF-8" class="product-item__action-list product-item__action-list--list-view-only button-stack kg-product-item-action-list" enctype="multipart/form-data">
                        <input type="hidden" name="form_type" value="product">
                        <input type="hidden" name="utf8" value="✓">
                        <input type="hidden" name="quantity" value="1">
                        <input type="hidden" name="id" value="${product.variant_id}">
                        <div class="kg-cart-container">
                            ${product.stock > 0 ?`<button type="button" title="${product.sku}" onclick="quotefunction(this)" class="kg-btn-quotes kg-btn button_quote_click">
                            Add to Quote
                            </button>`:''}
                            <button type="submit" class="product-item__action-button product-item__action-button--list-view-only button button--small button--primary kg-product-item-action-button kg-btn" data-action="add-to-cart" ${product.stock <= 0 ? 'style="max-width:100%;background-color:#1988d6;cursor:not-allowed"' : ''} ${product.stock <= 0 ? 'disabled' : ''}>
                                    ${product.stock <= 0 ? 'Sold Out' : 'Add to cart'}
                            </button>
                        </div>
                        <input type="hidden" name="product-id" value="${product.product_id}">
                        <input type="hidden" name="section-id" value="${product.section_id}">
                    </form>
                </div>
            </div>
        </div>`;

        $('body').find(whereToSet).append(productHTML);
    })
}

function openModal() {
    // Check if a WA postcode (starting with 6) is present and modal hasn't been shown before
    const postCode = localStorage.getItem('userPostCode');
    const modalAlreadyShown = localStorage.getItem('waStockModalShown');

    if (postCode && postCode.startsWith('6') && !modalAlreadyShown) {
        document.getElementById('waStockModal').style.display = 'flex';
    }
}

function closeModal() {
    document.getElementById('waStockModal').style.display = 'none';
    localStorage.setItem('waStockModalShown', 'true');
}

// Example function to set postcode (you'd typically call this when user enters their postcode)
function setPostCode(code) {
    localStorage.setItem('userPostCode', code);
    // Optionally try to open modal after setting postcode
    openModal();
}

// Close modal if user clicks outside of it
window.onclick = function(event) {
    const modal = document.getElementById('waStockModal');
    if (event.target == modal) {
        modal.style.display = 'none';
        localStorage.setItem('waStockModalShown', 'true');
    }
}

function estimate_shipping(suggested_value = null) {
    var payload = {};
    console.log(suggested_value, "suggested_value 1");
    $('.skeleton-text-loder').show();
    payload.zipcode = $('#shipping-estimator-zip').val();
    setPostCode(payload.zipcode)
    payload.country = 'Australia';
    payload.province = $('#shipping-estimator-province').val();
    payload.city = $('#shipping-estimator-city').val();
    $('#shipping-estimator-zip_popup').val(payload.city + ', ' + payload.province + ', ' + payload.zipcode);
    $('.kg-location-text').text(payload.city + ', ' + payload.province + ', ' + payload.zipcode);
    payload.product_id = product_id;
    payload.variant_id = variant_id;
    payload.quantity = $('.quantity-selector__value').val();
    payload.sku = sku;
    payload.selected_value = $('#shipping-estimator-zip_popup').val();

    $.ajax({
        url: "https://dashboard2.restaurantequipment.com.au/api/shipping/product-rate/nz",
        type: "POST",
        dataType: "json",
        contentType: "application/json;",
        data: JSON.stringify(payload),
        success: function(data) {
            $('#estimate_shipping_popup').removeClass('estimate_shipping_popup_loader');
            $('.icon--shipping-loader').hide();
            var typeDelivery = $('.kg-product-service-row .kg-product-servixe-main .kg-service-checkbox:checked').attr('data-type');
            var success_type = data.success;
            var payload = data;
            var data = data['data'];
            console.log(data);
            var resultsElement = $('.shipping_cost');
            var resultsElement1 = $('.shipping_cost1');

            var sold_out_form = $('.sold_out_form');

            var postcodeDetails = "2-5 Business Days";

            if (payload['postcodeDetails'] != null && payload['postcodeDetails'] != undefined) {
                postcodeDetails = payload['postcodeDetails']['delivery_time'];
            }
              $('.skeleton-text-loder').hide();
            var shippingRates = data['rates'];
            if (shippingRates.length === 0 || success_type == false) {
                jQuery('#kg-add-to-cart').prop('disabled', true);

                jQuery('.kg-no-shipping-rate-info').text('Please request a quote for this item to check delivery options.');

                jQuery('.kg_shipping_rate_responce').html('');
                var shippingcalhtml = '<strong>Sorry, no shipping rate.</strong>';
                // resultsElement.html("<p>".concat("Sorry, no shipping rate is found for your location.<br> Please contact us and we will request a quote <br>from our supplier", "</p>"));
                // var shippingcalhtml = '<li><svg xmlns="http://www.w3.org/2000/svg" width="50" height="45" viewBox="0 0 50 45" fill="none">' +
                //     '<path d="M49.4373 38.1956C51.0395 40.9728 49.0283 44.4444 45.8281 44.4444H4.17138C0.965042 44.4444 -1.03687 40.9674 0.562264 38.1956L21.3909 2.08203C22.9939 -0.696527 27.009 -0.691492 28.6091 2.08203L49.4373 38.1956ZM25 30.7292C22.7947 30.7292 21.007 32.5169 21.007 34.7222C21.007 36.9275 22.7947 38.7153 25 38.7153C27.2053 38.7153 28.9931 36.9275 28.9931 34.7222C28.9931 32.5169 27.2053 30.7292 25 30.7292ZM21.209 16.3762L21.8529 28.1818C21.883 28.7342 22.3398 29.1667 22.893 29.1667H27.107C27.6603 29.1667 28.117 28.7342 28.1472 28.1818L28.7911 16.3762C28.8236 15.7795 28.3485 15.2778 27.751 15.2778H22.249C21.6514 15.2778 21.1764 15.7795 21.209 16.3762Z" fill="#FFD43B"/>' +
                //     '</svg><p style="font-style:normal;">' +
                //     '<span>' +
                //     '<span class="shipping_cost" style="font-weight:bolder;text-align:center">Sorry, no shipping rate is found for your location.<br> Please contact us and we will request a quote <br>from our supplier</span>' +
                //     '</span>' +
                //     '</p></span></li>';
                jQuery('.kg_shipping_rate_responce').append(shippingcalhtml);
                jQuery('.kg-info-icon').hide();


                sold_out_form.show();
                $('.product-form__add-button').hide();
            } else {
                $('.product-form__add-button').show();

                var listRatesHtml = '';
                var shipping_description = '';
                var shippingRatesss = '';
                var hasFreeDelivery = false;
                var premiumRate = false;
                jQuery('.kg_shipping_rate_responce').html('');
                jQuery('.kg-free-delivery-div').hide(); 
                
                shippingRates.forEach(function(item, i) {
                      var price = parseFloat(item['total_price']) / 100;
                        if (
                            price === 0 &&
                            (
                            item['service_code'].includes('Delivery') ||
                            item['service_code'].includes('Kerbside')
                            )
                        ) {
                            hasFreeDelivery = true;
                           // return; 
                        }
                    
                    var standardCss = 'style="display:none"';
                    var premiumCss = 'style="display:none"';
                    if(typeDelivery == 'standard'){
                        standardCss = 'style="display:block"';
                    }
                    if(typeDelivery == 'premium'){
                        premiumCss = 'style="display:block"';
                    }

                    if(item['service_code'] == '<b>Kerbside Delivery - Dispatched by Supplier </b>' || '<b>Free Kerbside Delivery </b>' || item['service_code'] == '<b>Standard Kerbside Delivery </b>' || item['service_code'] == '<b>Free Delivery! </b>' || item['service_code'] == '<b>Kerbside Delivery </b>'){
                        shippingRatesss += '<strong id="kg_standard_delivery" '+standardCss+'>'+item['service_name'] + ' ' + "".concat("$" + (item['total_price'] / 100).toFixed(2), " ")+'</strong>';
                    }
                    else if(item['service_code'] == '<b>In-Store Delivery + Rubbish Removal <\/b>'){
                        shippingRatesss += '<strong id="kg_standard_delivery" '+standardCss+'>'+item['service_name'] + ' ' + "".concat("$" + (item['total_price'] / 100).toFixed(2), " ")+'</strong>';
                    }
                    else if(item['service_code'] == '<b>Free Kerbside Delivery! </b>' || item['service_code'] == '<b>Standard Kerbside - Free Delivery </b>' || item['service_code'] == '<b>Standard Kerbside Delivery </b>' || item['service_code'] == '<b>Free Delivery! </b>' || item['service_code'] == '<b>Kerbside Delivery </b>'){
                        shippingRatesss += '<strong id="kg_standard_delivery" '+standardCss+'>'+item['service_name'] + ' ' + "".concat("$" + (item['total_price'] / 100).toFixed(2), " ")+'</strong>';
                    }
                    else if(item['service_code'] == 'Machship'){
                        shippingRatesss += '<strong id="kg_standard_delivery" '+standardCss+'>'+item['service_name'] + ' ' + "".concat("$" + (item['total_price'] / 100).toFixed(2), " ")+'</strong>';
                    }
                    if(item['service_code'] == 'PFM Logistics'){
                        premiumRate = true;
                        shippingRatesss += '<strong id="kg_premium_delivery" '+premiumCss+'>'+item['service_name'] + ' ' + "".concat("$" + (item['total_price'] / 100).toFixed(2), " ")+'</strong>';
                    }

                    if (i <= 0){
                    var dispatchName = '';
                    if (item['service_code'] == '<b>Standard Kerbside - Free Delivery </b>' || item['service_code'] == '<b>Standard Kerbside Delivery </b>' || item['service_code'] == '<b>Free Delivery! </b>' || item['service_code'] == '<b>Kerbside Delivery </b>') {
                        var shipping_description = ' <span>Delivery in <span id="shipping_time">' + postcodeDetails + '</span>, courier will call 24hr before</span>';
                    } else if (item['service_code'] == 'PFM Logistics') {
                        var shipping_description = ' <span>We will contact you after checkout to arrange your delivery</span>';
                    } else if (item['service_image'] !== undefined || item['service_image'] !== '') {
                        //var shipping_description=' '+item['description'];
                        var shipping_description = item['description'];

                            shipping_description = shipping_description.replace(/<br\s*\/?>/gi, ' ');

                            shipping_description = shipping_description
                            .replace('Thursday', 'Thu')
                            .replace('Tuesday', 'Tue')
                            .replace('Wednesday', 'Wed');

                            shipping_description = shipping_description.replace(
                            /(\d{2})\s(January|February|March|April|May|June|July|August|September|October|November|December)\s(\d{4})/g,
                            function (_, day, month, year) {
                                const monthMap = {
                                January: '01', February: '02', March: '03', April: '04',
                                May: '05', June: '06', July: '07', August: '08',
                                September: '09', October: '10', November: '11', December: '12'
                                };
                                return `${day} ${monthMap[month]} ${year}`;
                            }
                            );

                           
                           

                                // ✅ Wrap ONLY ONCE
                                shipping_description = `<p>${shipping_description}</p>`;

                                if (typeDelivery === 'standard' ) {
                                $('#kg-tag-shipping-cfs').show();
                                } else {
                                $('#kg-tag-shipping-cfs').hide();
                                }

                                console.log(shipping_description);


                    } else {
                        var shipping_description = '';
                    }
                    if (item['from'] !== undefined && item['from'] !== "" && item['from'] !== null) {

                        // shipping_description = shipping_description+"<br>(Dispatched from "+item['from']+" Warehouse)";
                        dispatchName = shipping_description+"<br>(Dispatched from "+item['from']+" Warehouse)";
                        // if(item['from'] == "EC"){
                        //     var dispatchName = 'Dispatched from Syd/Melb';     
                        // }else {
                        //     var stateCityMap = {
                        //         'NSW': 'Sydney',
                        //         'VIC': 'Melbourne',
                        //         'QLD': 'Brisbane',
                        //         'SA': 'Adelaide',
                        //         'WA': 'Perth'
                        //     };

                        //     var state = item['from'];
                        //     var city = stateCityMap[state] || '';

                        //     var dispatchName = city
                        //         ? 'Dispatched from ' + city + ', ' + state
                        //         : 'Dispatched from ' + state;
                        //     }

                            if(typeDelivery == 'standard'){

                                if($('#kg-tag-shipping-cfs .kg_shipping_rate_cfs-response').html()){
                                    $('#kg-tag-shipping-cfs').show();
                                }
                                 
                                 if($('#kg-tag-shipping-from-tag .kg_shipping_from-tag-response').html()){
                                    $('#kg-tag-shipping-from-tag').show();
                                }
                            }else{
                                $('#kg-tag-shipping-from-tag').hide();
                                $('#kg-tag-shipping-cfs').hide();
                            }

                     
                    }


                        if(typeDelivery == 'standard'){
                            console.log(typeDelivery,'typeDeliverytypeDeliverytypeDelivery')
                 

                            setTimeout(function () {
                                
                                if($('#kg-tag-shipping-cfs .kg_shipping_rate_cfs-response').html()){
                                    $('#kg-tag-shipping-cfs').show();
                                }
                                 
                                 if($('#kg-tag-shipping-from-tag .kg_shipping_from-tag-response').html()){
                                    $('#kg-tag-shipping-from-tag').show();
                                }
                            }, 500); 

                            }else{
                                $('#kg-tag-shipping-from-tag').hide();
                                $('#kg-tag-shipping-cfs').hide();
                            }
        
                    var shippingcalhtml = '<li><span class="kg_shipping_service"><p>' +
                        shipping_description +
                        '</p></span></span>';

                    //  if (item['service_code'] == 'PFM Logistics') {
                    //      shippingcalhtml += '<span class="kg-toolips kg-PFM-service">In-Store Delivery - Products delivered inside your shop by two man team. Subject to delivery terms</span>';
                    // } else {
                    //      shippingcalhtml += '<span class="kg-toolips">Kerbside delivery - Products delivered to your front door or loading bay by single delivery driver</span>';
                    // }

                    shippingcalhtml += '</li>';
                    jQuery('.kg_shipping_rate_cfs-response').html(shippingcalhtml);
                   
                      if (dispatchName && dispatchName.trim() !== '') {
                        var shippingcalhtml = '<li><span class="kg_shipping_service"><p>' +
                            dispatchName +
                            '</p></span></li>';

                        jQuery('.kg_shipping_from-tag-response').html(shippingcalhtml);
                            $('#kg-tag-shipping-from-tag').show();
                        } else{
                            $('#kg-tag-shipping-from-tag').hide();
                        }

                }
                });

                 shippingRatesss += '<strong id="kg_pickup_delivery" style="display:none">Click and Collect</strong><div class="skeleton-text-loder" style="display:none">';
                if (hasFreeDelivery) {
                    jQuery('.kg-free-delivery-div').show();
                }

                if(premiumRate){
                    jQuery('.kg-service-checkbox-premium').removeClass('kg-disabled-premium');
                }else{
                    jQuery('.kg-service-checkbox-premium').addClass('kg-disabled-premium');
                }
                jQuery('.kg_shipping_rate_responce').html(shippingRatesss);
               
                sold_out_form.hide();

            }


            if (suggested_value != null) {
                $.each(allPincode, function(k, v) {
                    console.log(v, 'suggested_value', suggested_value, 'suggested_value')
                    if (v.name == suggested_value) {
                        $('body').find('#shipping_time').text(v.delivery_time);
                        console.log(v, "testing");
                    }
                });

                $('#shipping-estimator-zip_popup').val(suggested_value);
                 $('.kg-location-text').text(suggested_value);
            } else {}
        },
        error: function(err) {
            // check the err for error details
        }
    });
}

$('#estimate_shipping_popup').click(function() {
    $('#wrong_zip').text('');
    var valid_zip_main = $('#shipping-estimator-zip_popup').val();
    var valid_zip_array = valid_zip_main.split(',');
    var valid_zip = valid_zip_array[valid_zip_array.length - 1].trim();

    console.log(valid_zip, valid_zip_array, allPincode, "valid_zip valid_zip");

    if (valid_zip != "" && valid_zip != null) {
        var province_popup = valid_zip_array[1];

        if (province_popup != '' && province_popup != null && valid_zip != "" && valid_zip != null) {
            console.log(province_popup, valid_zip)
            $('#shipping-estimator-province').val(province_popup.trim());
            $('#shipping-estimator-zip').val(valid_zip);
            $('#shipping-estimator-city').val(valid_zip_array[0]);
            $('#shipping-estimator').find('.form__submit').trigger('click');
            check_zip = valid_zip_main;
            $('#estimate_shipping_popup').addClass('estimate_shipping_popup_loader');
            $('.icon--shipping-loader').show();
            estimate_shipping(valid_zip_main)
        } else {
            $('#wrong_zip').text('Enter valid zipcode');
        }

    } else {
        $('#wrong_zip').text('Enter valid zipcode');
    }
});

$(document).on("click", "#kg_sold_form", function() {
    $('.kg-form-iframe-container').toggleClass("active");
});

$(".kg-addtocart-preorder-btn").click(function() {
    var heightHeader = jQuery(".shopify-section__header").height();
    $('html,body').animate({
        scrollTop: $('.product-info__block-item--payment-card-block').offset().top - heightHeader
    }, 500);
    return false;
});

function sticky_relocate() {
    var window_top = $(window).scrollTop();
    var div_top = $('.product-form__buy-buttons').offset().top;
    var aa = $(".topbar-section").height();
    var bb = $(".product-form__buy-buttons").height();
    var nn = div_top - aa + bb;
    if (window_top > nn) {
        $('#kg-bottom-card-section').addClass('kg-bottom-sticky');
        $('.product-form__payment-container').addClass('kg-bottom-sticky');
    } else {
        $('#kg-bottom-card-section').removeClass('kg-bottom-sticky');
        $('.product-form__payment-container').removeClass('kg-bottom-sticky');
    }
}

$(function() {
    $(window).scroll(sticky_relocate);
    sticky_relocate();
});
$(document).ready(function() {
    $("#kg-tooltip-area").click(function() {
        $(".kg-copied").css("display", "block");
        setTimeout(function() {
            $(".kg-copied").hide();
        }, 1000);
    });
})
$(document).on("click", ".kg-last-price-plus-icon", function() {
    $('.kg-last-price-label').addClass("active");
    $('.kg-last-price-content').show();
});
$(document).on("click", ".kg-last-price-minus-icon", function() {
    $('.kg-last-price-label').removeClass("active");
    $('.kg-last-price-content').hide();
});


$(document).on("click", ".kg-last-price", function() {

    if ($('.kg-last-price-plus-icon').length) {
        var heightHeader = jQuery(".shopify-section__header").height();

        $('html,body').animate({
            scrollTop: $('.kg-last-price-promise-content').offset().top - heightHeader
        }, 1000, function() {
            if (!$('.kg-last-price-label').hasClass('active')) {
                $('.kg-last-price-plus-icon').click();
            }
        });
    }
});
$(document).on('click', '.cc-gst .kg-gst-toggle1', function () {
  var ccChcBox = $(this).find('.toggle1');

  if (ccChcBox.prop('checked')) {
      $('.kg-product-price.kg-including-price').show();
      $('.kg-product-price.kg-excluding-price').hide();
    
  } else {
      $('.kg-product-price.kg-including-price').hide();
      $('.kg-product-price.kg-excluding-price').show();
   
  }
});


  function updateTitleHeight() {
  var titleHeight = $('.product-block-list .product-block-list__wrapper .product-block-list__item.product-block-list__item--info .card__section .product-meta h1.product-meta__title.heading.h1').outerHeight();
  document.documentElement.style.setProperty('--product-title-height', titleHeight + 'px');

  const priceElement = $('.product-block-list .product-block-list__wrapper .kg-including-price:visible .price-list, .product-block-list .product-block-list__wrapper .kg-excluding-price:visible .price-list');
  const priceMatchElement = $('.product-block-list .product-block-list__wrapper .kg-including-price:visible .price__match, .product-block-list .product-block-list__wrapper .kg-excluding-price:visible .price__match');

  
  let priceWidth = 0;
  let matchWidth = 0;
  
  if (priceElement.length > 0) {
    priceWidth = priceElement.outerWidth();
    document.documentElement.style.setProperty('--product-price-width', priceWidth + 'px');
      console.log("--product-price-width:", priceWidth);

  }

  
  if (priceMatchElement.length > 0) {
    matchWidth = priceMatchElement.outerWidth();
    document.documentElement.style.setProperty('--price-match-width', matchWidth + 'px');
      console.log("--price-match-width:", matchWidth);

  }
  
  // Sum both widths
  const totalWidth = priceWidth + matchWidth;
  document.documentElement.style.setProperty('--total-price-block-width', totalWidth + 'px');
  console.log("Total Price Block Width:", totalWidth);

    
}


$(document).ready(function () {
  updateTitleHeight();

  // Update on window resize
  $(window).on('resize', function () {
    updateTitleHeight();
  });
});
$(document).on('click', '.kg-edit-icon, .kg-location-text', function (e) {
    e.stopPropagation();
    $('.kg-location-text').hide();
    $('.kg-location-wrap').show();
});

$(document).on('click', function (e) {
    if (
        !$(e.target).closest('.kg-location-wrap').length &&
        !$(e.target).closest('.kg-edit-icon').length &&
        !$(e.target).closest('.kg-location-text').length
    ) {
        $('.kg-location-wrap').hide();
        $('.kg-location-text').show();
    }
});

$('.kg-service-checkbox').on('change', function () {
     if (!this.checked) {
    this.checked = true;
    return;
  }
  $('.kg-service-checkbox').not(this).prop('checked', false);

  $('#kg_standard_delivery, #kg_premium_delivery, #kg_pickup_delivery').hide();
  $('.kg-shipping-days-info, .kg-shipping-premium-info, .kg-shipping-pickup-time-info').hide();
  $('#kg-tag-shipping-cfs').hide();
  $('#kg-tag-shipping-from-tag').hide();
   $('#kg-tag-shipping-premium-cfs').hide();

  $('#kg-store-locations-hidden').hide();
  $('.kg-location-row').show();

  if ($(this).is(':checked')) {
    let type = $(this).data('type');

    if (type === 'standard') {
      $('#kg_standard_delivery').show();
      if($('#kg-tag-shipping-cfs .kg_shipping_rate_cfs-response').html()){
            $('#kg-tag-shipping-cfs').show();
        }
      if($('#kg-tag-shipping-from-tag .kg_shipping_from-tag-response').html()){
          $('#kg-tag-shipping-from-tag').show();
      }
     
      $('.kg-shipping-days-info').show();
    } 
    else if (type === 'premium') {
      $('#kg_premium_delivery').show();
    $('#kg-tag-shipping-cfs').hide();
    $('#kg-tag-shipping-premium-cfs').show(); 
      if($('#kg-tag-shipping-from-tag .kg_shipping_from-tag-response').html()){
      $('#kg-tag-shipping-from-tag').show();
      }
      $('.kg-shipping-premium-info').show();
    } 
    else if (type === 'pickup') {
      $('#kg_pickup_delivery').show();
      $('#kg-tag-shipping-cfs').hide();
      $('#kg-tag-shipping-from-tag').hide();
      $('.kg-shipping-pickup-time-info').show();
      $('#kg-store-locations-hidden').show();
      $('.kg-location-row').hide();
    }
  }
});
// jQuery(document).ready(function () {
//  function setPriceWidthVar() {
//   var $price = jQuery(
//     '.product-block-list .product-block-list__wrapper ' +
//     '.kg-including-price:visible .price-list .price:visible, ' +
//     '.product-block-list .product-block-list__wrapper ' +
//     '.kg-excluding-price:visible .price-list .price:visible'
//   );

//   if (!$price.length) return;

//   var priceWidth = Math.ceil($price[0].getBoundingClientRect().width);

//   if (priceWidth > 0) {
//     document.documentElement.style.setProperty(
//       '--price-main-width',
//       priceWidth + 'px'
//     );
//   }
// }

//   requestAnimationFrame(function () {
//     setTimeout(setPriceWidthVar, 150);
//   });
//   jQuery(window).on('resize', function () {
//     setTimeout(setPriceWidthVar, 100);
//   });
//   jQuery(document).on('change click', '.kg-gst-toggle1, .kg-gst-toggle1 input', function () {
//   requestAnimationFrame(function () {
//     setTimeout(setPriceWidthVar, 50);
//   });
// });

// });
